<template>
  <div class="page-wrapper">
    <div class="searchBox">
      <div class="left">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-select
              v-model="searchForm.initiatorUserType"
              clearable
              placeholder="请选择发起方用户类型"
            >
              <el-option label="主播" :value="1"></el-option>
              <el-option label="企业" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.status"
              clearable
              placeholder="请选择邀约状态"
            >
              <el-option label="待确认" :value="1"></el-option>
              <el-option label="已拒绝" :value="0"></el-option>
              <el-option label="已接受" :value="2"></el-option>
              <el-option label="邀约成功" :value="3"></el-option>
              <el-option label="邀约超时" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" size="small">
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="主播">
          <template slot-scope="scope">
            <p>
              <el-tag size="mini" type="info" effect="plain" v-if="scope.row.steamerId == scope.row.submitUserId"
                title="发起方"
              >发</el-tag>
              {{scope.row.nickname}}
            </p>
            <p>{{scope.row.cellphoneNumber}}</p>
            
          </template>
        </el-table-column>
        <el-table-column label="企业">
          <template slot-scope="scope">
            <p>
              <el-tag size="mini" type="info" effect="plain" v-if="scope.row.companyId == scope.row.submitUserId"
                title="发起方"
              >发</el-tag>
              {{scope.row.companyName}}
            </p>
            <p>{{scope.row.contactNumber}}</p>
            
          </template>
        </el-table-column>
        <el-table-column label="邀约状态">
          <template slot-scope="scope">
            <el-tag size="small" type="danger" v-if="scope.row.status === 0">已拒绝</el-tag>
            <el-tag size="small" type="info" v-if="scope.row.status === 1">待确认</el-tag>
            <el-tag size="small" v-if="scope.row.status === 2">已接受</el-tag>
            <el-tag size="small" type="success" v-if="scope.row.status === 3">邀约成功</el-tag>
            <el-tag size="small" type="warning" v-if="scope.row.status === 4">邀约超时</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="约见时间">
          <template slot-scope="scope">
            {{scope.row.appointmentTime ? scope.row.appointmentTime : '-'}}
          </template>
        </el-table-column>
        <el-table-column label="约见地点"  width="250">
          <template slot-scope="scope">
            {{scope.row.appointmentLocation ? scope.row.appointmentLocation : '-'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="left">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="openDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              v-if="scope.row.status === 2"
              type="primary"
              plain
              size="mini"
              @click="openInvite(scope)"
              >邀约</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        background
      >
      </el-pagination>
    </div>

    <el-dialog
      title="邀约信息"
      :visible.sync="detailVisible"
      width="800px"
    >
      <div class="detail-wrap">
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">主播昵称：</span>
              <span class="value">{{detailData.nickname}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">企业名称：</span>
              <span class="value">{{detailData.companyName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">主播电话：</span>
              <span class="value">{{detailData.cellphoneNumber}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">企业电话：</span>
              <span class="value">{{detailData.contactNumber}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">邀约状态：</span>
              <span class="value">
                <el-tag size="mini" type="danger" v-if="detailData.status === 0">已拒绝</el-tag>
                <el-tag size="mini" type="info" v-if="detailData.status === 1">待确认</el-tag>
                <el-tag size="mini" v-if="detailData.status === 2">已接受</el-tag>
                <el-tag size="mini" type="success" v-if="detailData.status === 3">邀约成功</el-tag>
                <el-tag size="mini" type="warning" v-if="detailData.status === 4">邀约超时</el-tag>
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">发起方：</span>
              <span class="value">{{detailData.submitUserId == detailData.companyId ? '企业' : '主播'}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">约见时间：</span>
              <span class="value">
                {{detailData.appointmentTime || '-'}}
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">约见地点：</span>
              <span class="value">
                {{detailData.appointmentLocation || '-'}}
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">发起邀约时间：</span>
              <span class="value">{{detailData.submitTime || '-'}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <span class="label">接受或拒绝时间：</span>
              <span class="value">{{detailData.updateTime || '-'}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="line">
              <span class="label">管理员撮合时间：</span>
              <span class="value">{{detailData.adminTime || '-'}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog
      title="时间地点确认"
      :visible.sync="inviteVisible"
      :close-on-click-modal="false"
      width="600px"
    > 
      <div style="padding: 40px 40px 16px 0">
        <el-form :model="inviteForm" :rules="inviteRules" ref="inviteForm" label-width="120px">
          <el-form-item label="约见时间：" prop="appointmentTime">
            <el-date-picker
              v-model="inviteForm.appointmentTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="约见地点：" prop="appointmentLocation">
            <el-input type="textarea" 
              :autosize="{ minRows: 2, maxRows: 4}"
              v-model="inviteForm.appointmentLocation" 
              placeholder="请输入约见地点"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="inviteVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitInviteForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { api, request } from "@/common/request_talent.js";
import { Loading } from 'element-ui';
export default {
  name: "serviceList",
  data() {
    return {
      isLoading: false,
      searchForm: {
        initiatorUserType: '',
        status: '',
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      //表格
      tableData: [],
      detailVisible: false,
      detailData: {},
      inviteVisible: false,
      inviteForm: {
        appointmentTime: '',
        appointmentLocation: '',
      },
      inviteRules: {
        appointmentTime: [
          { required: true, message: '请选择约见时间', trigger: 'change' }
        ],
        appointmentLocation: [
          { required: true, message: '请输入约见地点', trigger: 'change' }
        ],
      },
      rowIndex: null
    };
  },
  computed: {
    adminId() {
      return utils.getAdminId();
    },
    token() {
      return utils.getToken();
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        let query = route.query
        this.pagination.size = Number(query.size)
          ? Number(query.size)
          : 10;
        this.pagination.current = Number(query.current)
          ? Number(query.current)
          : 1;
        this.searchForm.initiatorUserType = query.initiatorUserType 
          ? Number(query.initiatorUserType)
          : ''
        this.searchForm.status = query.status 
          ? Number(query.status)
          : ''
        this.getCompanyList();
      },
      immediate: true,
    },
  },
  methods: {
    getCompanyList() {
      this.isLoading = true;
      let params =  {
        current: this.pagination.current,
        size: this.pagination.size,
      }
      let initiatorUserType = this.searchForm.initiatorUserType
      if (initiatorUserType !== '') params.initiatorUserType = +initiatorUserType

      let status = this.searchForm.status
      if (status !== '') params.status = +status
      
      request({
        url: api.baseUrl + "/talent-transaction-service/page",
        method: "get",
        params: params,
      })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.pagination.total = parseInt(res.data.total);
            this.tableData = res.data.records;
          } else {
            this.$message.error(res.msg || "获取列表信息失败");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openDetail(row) {
      this.detailData = row
      this.detailVisible = true
    },
    openInvite(scope) {
      console.log(scope)
      this.detailData = scope.row
      this.rowIndex = scope.$index
      // this.inviteForm.appointmentTime = this.detailData.appointmentTime || ''
      // this.inviteForm.appointmentLocation = this.detailData.appointmentLocation || ''
      this.inviteVisible = true
    },
    submitInviteForm() {
      console.log(this.inviteForm)
      this.$refs['inviteForm'].validate((valid) => {
        if (valid) {
          console.log('submit!');
          let timeStr = this.inviteForm.appointmentTime.replace(/-/g, '/')
          let t1 = new Date(timeStr).getTime()
          let t2 = new Date().getTime()
          if (t1 <= t2) {
            this.$message.error('约见时间应大于当前时间')
            return;
          }
          this.matchInvitation()
        }
      });
    },
    matchInvitation() {
      let loadingInstance = Loading.service({
        text: '正在提交...'
      });
      request({
        url: api.baseUrl + "/talent-transaction-service/platformMatchInvite",
        method: "post",
        data: {
          adminId: this.adminId,
          appointmentTime: this.inviteForm.appointmentTime,
          appointmentLocation: this.inviteForm.appointmentLocation,
          inviteId:this.detailData.id
        }
      })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.tableData[this.rowIndex].appointmentTime = this.inviteForm.appointmentTime
            this.tableData[this.rowIndex].appointmentLocation = this.inviteForm.appointmentLocation
            this.tableData[this.rowIndex].status = 3
            this.inviteVisible = false
            this.$refs['inviteForm'].resetFields();
            this.$message.success('提交成功')
          } else {
            this.$message.error(res.msg || "网络错误");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loadingInstance.close();
        });
    },
    searchHandle() {
      console.log(this.searchForm);
      console.log("searchHandle");
      this.pagination.page = 1;
      this.updateRouter();
    },
    updateRouter() {
      let str = "?current=" +
        this.pagination.current +
        "&size=" +
        this.pagination.size

      if (this.searchForm.initiatorUserType !== '') {
        str += "&initiatorUserType=" + this.searchForm.initiatorUserType
      }

      if (this.searchForm.status !== '') {
        str += "&status=" + this.searchForm.status
      }

      str += '&r=' + new Date().getTime()

      this.$router.push(
        "/service/list" + str
      );
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.pagination.size = size;
      this.pagination.current = 1;
      this.updateRouter();
    },
    handleCurrentChange(current) {
      //分页：改变第n页
      this.pagination.current = current;
      this.updateRouter();
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
}
.searchBox {
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.searchBox:after {
  content: "";
  display: block;
  clear: both;
}
.tableBox {
  padding: 16px 0;
}
.detail-wrap {
  padding: 16px 16px 64px;
  .line { padding: 16px 0; display: flex;}
  .label {width: 120px; text-align: right; padding-right: 8px; color: #666; flex-shrink: 0; font-size: 13px;}
  .value {color: #000; font-size: 13px;}
  .img {width: 64px; height: 64px; object-fit: cover; margin-right: 8px;}
}

</style>



// WEBPACK FOOTER //
// src/pages/service/list.vue